import { addNotificationInfo, addNotificationError } from "./toaster";
import { storeTokenReinitPassword, storeLanguage, lang_fr } from "./store";
import { idPageHome, idPageModifPassword } from "../scripts/router2";
import { redirectTo } from '../scripts/router1';
import { activate } from "./apiUsers";
import { get } from "svelte/store";
/**
 * resetToActivate
 */
export function resetToActivate() {
    const urlParams = new URLSearchParams(window.location.search);
    const isReinit = urlParams.has('reinit');
    if (isReinit) {
        const id = urlParams.get('id');
        const token = urlParams.get('token');
        const $waitConfirmation = activate(id, token);
        $waitConfirmation.then((data) => {
            if (data) {
                if (get(storeLanguage) == get(lang_fr)) {
                    addNotificationInfo("Saisissez un nouveau mot de passe");
                }
                else {
                    addNotificationInfo("Enter a new password");
                }
                storeTokenReinitPassword.set(token);
                redirectTo(idPageModifPassword);
            }
            else {
                if (get(storeLanguage) == get(lang_fr)) {
                    addNotificationError("Réinitialisation invalide");
                }
                else {
                    addNotificationError("Invalid reset");
                }
                redirectTo(idPageHome);
            }
        });
    }
}
